import {useBootstrap} from '@front/hooks';
import {$fetch, $post, getBaseURL, setChannels, setContexts} from '@/services';

const { setBootstrapData } = useBootstrap();

export function login(data) {
  return $post(`/login`, data).then(res => {
    return res;
  });
}

export function logout() {
  return $post(`/logout`);
}

export function loadCaptcha(data) {
  return $fetch(`/public/captcha`, data);
}

export function register(data) {
  return $post(`/register`, data).then(res => {
    return res;
  });
}
export function getAccountByCode(data) {
  return $post(`/getAccountByCode`, data).then(res => {
    return res;
  });
}

export function emailVerify(data) {
  return $post(`/emailVerify`, data).then(res => {
    return res;
  });
}

export function codeVerify(data) {
    return $post(`/codeVerify`, data).then(res => {
        return res;
    });
}

// invite reg 验证码通过后 下载页面获得app url 
export function getAppDownloadUrl(data) {
    return $post(`/getAppDownloadUrl`, data).then(res => {
        return res;
    });
}

export function resendVerify(data) {
    return $post(`/resendActivateCode`, data).then(res => {
        return res;
    });
}

export function bootstrap(data) {
  return $post(`/refresh`, data).then(res => {
    setBootstrapData(res);
    return res;
  });
}

export function changePassword(data) {
  return $post(`/changePassword`, data);
}

export function checkResetPasswordCode(data) {
  return $post(`/checkResetPasswordCode`, data).then(res => {
    return res;
  });
}

export function resetPasswordRequest(data) {
  return $post(`/resetPasswordRequest`, data);
}

export function resetPassword(data) {
  return $post(`/resetPassword`, data);
}

export function loadPublicBootstrap() {
  return $fetch(`/public/bootstrap`);
}

export function initChannels() {
  return $fetch('/public/channel').then(setChannels);
}

export function initContexts() {
  return $fetch('/public/context').then(setContexts);
}

/**
 * @return
 *  成功: 延时毫秒数
 *  失败: timeout or ajax error
 */
export function pingChannel(channel, timeout = 10 * 1000) {
  // return Promise.reject('timeout');
  // if (channel.startsWith('p2')) return Promise.reject('timeout');
  const api = '/public/ping';
  if (!channel) throw 'pingChannel: channel is required';
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => reject('timeout'), timeout);
    const startTime = Date.now();
    $fetch(getBaseURL(channel) + api)
      .then(() => {
        resolve(Date.now() - startTime);
      })
      .catch(reject)
      .finally(() => {
        clearTimeout(timer);
      });
  });
}
